import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import FalconCardHeader from 'components/common/FalconCardHeader';

const InsightsSkeleton = () => {
  return (
    <Card className="h-100">
      <FalconCardHeader title={<Skeleton />} titleTag="h5" light={true} />
      <Card.Body className="z-index-1 d-flex flex-column justify-content-around text-center">
        <Skeleton circle height={220} width={220} />
        <p>
          <Skeleton count={2} />
        </p>
      </Card.Body>
    </Card>
  );
};

export default InsightsSkeleton;
